/* ==========================================================================
   VoxTune — Predictive Search
   Instant AJAX results via Shopify's /search/suggest.json. No page reloads.
   Opened by any [data-vp-search] trigger. Builds its overlay on first use.
   ========================================================================== */
(function (w, d) {
  'use strict';
  var VT = w.VoxTune;
  var root = null, input = null, results = null, t = null, lastQ = '', lastFocus = null;

  function build() {
    if (root) return root;
    root = d.createElement('div');
    root.className = 'vp-search-root';
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="vp-search-scrim" data-close style="position:fixed;inset:0;z-index:130;background:rgba(6,7,9,.6);backdrop-filter:blur(4px);animation:vpFade .2s both"></div>' +
      '<div role="dialog" aria-modal="true" aria-label="Search" style="position:fixed;left:0;right:0;top:0;z-index:131;background:#fff;border-bottom:1px solid var(--vp-border,#E5E3DE);animation:vpRise .25s both">' +
        '<div style="max-width:760px;margin:0 auto;padding:18px clamp(16px,4vw,24px)">' +
          '<form class="vp-search-form" role="search" action="/search" method="get" style="display:flex;gap:10px;align-items:center">' +
            '<input class="vp-search-input" type="search" name="q" autocomplete="off" placeholder="Search presets, artists, packs…" aria-label="Search" style="flex:1;font-size:18px;padding:14px;border:1px solid var(--vp-border,#E5E3DE);font-family:inherit">' +
            '<button type="button" data-close aria-label="Close" style="width:46px;height:46px;border:1px solid var(--vp-border,#E5E3DE);background:#fff;cursor:pointer;font-size:18px">✕</button>' +
          '</form>' +
          '<div class="vp-search-results" aria-live="polite" style="margin-top:14px;max-height:60vh;overflow-y:auto"></div>' +
        '</div>' +
      '</div>';
    d.body.appendChild(root);
    input = root.querySelector('.vp-search-input');
    results = root.querySelector('.vp-search-results');
    root.addEventListener('click', function (e) { if (e.target.hasAttribute('data-close')) close(); });
    input.addEventListener('input', function () { schedule(input.value.trim()); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && !root.hidden) close(); });
    // Keep Tab focus inside the open overlay.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || root.hidden) return;
      var f = root.querySelectorAll('button:not([disabled]),a[href],input,[tabindex]:not([tabindex="-1"])');
      f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    return root;
  }

  function open() { build(); lastFocus = d.activeElement; root.hidden = false; d.body.style.overflow = 'hidden'; setTimeout(function () { input.focus(); }, 30); }
  function close() { if (!root || root.hidden) return; root.hidden = true; d.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }

  function schedule(q) {
    clearTimeout(t);
    if (q.length < 2) { results.innerHTML = ''; return; }
    t = setTimeout(function () { run(q); }, 180);
  }

  function esc(s) { var e = d.createElement('span'); e.textContent = s == null ? '' : String(s); return e.innerHTML; }
  // Escape + only allow http(s)/relative/protocol-relative URLs (blocks javascript: etc.).
  function safeUrl(u) { u = String(u == null ? '' : u); return /^(https?:\/\/|\/)/.test(u) ? esc(u) : '#'; }
  function money(c) { return VT && VT.money ? VT.money(c) : '$' + (c / 100).toFixed(2); }
  // /search/suggest.json returns prices as currency strings ("29.99") or integer
  // cents depending on field — normalise to cents so money() formats correctly
  // (the old code passed "29.99" straight to money() → "$0.30").
  function toCents(v) {
    if (v == null || v === '') return null;
    var s = String(v).trim();
    if (s.indexOf('.') > -1) { var n = parseFloat(s.replace(/[^0-9.\-]/g, '')); return isNaN(n) ? null : Math.round(n * 100); }
    var i = parseInt(s.replace(/[^0-9\-]/g, ''), 10); return isNaN(i) ? null : i;
  }
  function priceBlock(p) {
    var pc = toCents(p.price != null ? p.price : p.price_min);
    if (pc == null) return '';
    var cmp = toCents(p.compare_at_price_max != null ? p.compare_at_price_max : (p.compare_at_price_min != null ? p.compare_at_price_min : p.compare_at_price));
    var sale = cmp != null && cmp > pc;
    return '<span class="vp-mono" style="font-size:12px;display:inline-flex;gap:6px;align-items:baseline;white-space:nowrap">' +
      (sale ? '<s style="color:#A6A39C">' + money(cmp) + '</s>' : '') +
      '<span style="color:var(--vp-accent,#FF9A3D)">' + money(pc) + '</span></span>';
  }

  function run(q) {
    if (q === lastQ) return; lastQ = q;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last';
    results.innerHTML = '<div class="vp-mono" style="color:var(--vp-muted,#8A8C93);padding:14px">Searching…</div>';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (q !== lastQ) return;
        var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
        var colls = (data.resources && data.resources.results && data.resources.results.collections) || [];
        if (!prods.length && !colls.length) { results.innerHTML = '<div style="padding:18px;color:var(--vp-muted,#8A8C93)">No matches for “' + esc(q) + '”.</div>'; return; }
        var html = prods.map(function (p) {
          var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || (p.image) || '';
          var src = img ? (img + (img.indexOf('?') < 0 ? '?width=120' : '&width=120')) : '';
          return '<a href="' + safeUrl(p.url) + '" style="display:flex;align-items:center;gap:12px;padding:10px;border-bottom:1px solid #EFEDE8;text-decoration:none;color:var(--vp-ink,#0A0B0D)">' +
            (img ? '<img src="' + esc(src) + '" alt="" width="44" height="44" loading="lazy" style="width:44px;height:44px;object-fit:cover;border:1px solid var(--vp-border,#E5E3DE)">' : '') +
            '<span style="flex:1;font-weight:700;font-size:15px">' + esc(p.title) + '</span>' +
            priceBlock(p) + '</a>';
        }).join('');
        var chtml = colls.map(function (c) {
          return '<a href="' + safeUrl(c.url) + '" class="vp-mono" style="display:inline-block;margin:8px 8px 0 0;padding:8px 12px;border:1px solid var(--vp-border,#E5E3DE);text-decoration:none;color:var(--vp-ink,#0A0B0D);font-size:12px">' + esc(c.title) + '</a>';
        }).join('');
        results.innerHTML = html + (chtml ? '<div style="padding:12px 4px">' + chtml + '</div>' : '');
        if (VT) VT.track('ProductViewed', { context: 'predictive-search', q: q });
      })
      .catch(function () { results.innerHTML = '<div style="padding:18px;color:var(--vp-muted,#8A8C93)">Search unavailable.</div>'; });
  }

  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-vp-search]');
    if (t) { e.preventDefault(); open(); if (VT) VT.emit('sound:play', 'click'); }
  });
})(window, document);
